import axios from 'axios'

const ReceivingService = {
  async get (params = {}) {
    return axios.get('po/inter-warehouse-transfer/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('po/reports/inter-warehouse-transfer/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('po/exports/inter-warehouse-transfer/receivings', { params })
  },

  async show (id) {
    return axios.get(`po/inter-warehouse-transfer/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/inter-warehouse-transfer/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/inter-warehouse-transfer/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/inter-warehouse-transfer/receivings/${data.id}`, { data })
  }
}

export default ReceivingService
